import { Box, Button, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

export const Section = styled(Box)(({ theme: { breakpoints } }) => ({
  padding: '64px 0',
  [breakpoints.up('md')]: {
    padding: '34px 0',
  },
}))

// The section runs taller than the frame's because of the cover PNG's shadow margin, so the text sits 5px higher
// to land where the frame centers it.
export const TextBox = styled(Box)(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    top: -5,
  },
}))

export const Title = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    fontSize: 28,
  },
}))

export const PreviewButton = styled(Button)({
  minWidth: 220,
  padding: '12px 24px',
})
